// extracted by mini-css-extract-plugin
export default {"contentDisplay":"styles_contentDisplay__5g6iS","fullWidth":"styles_fullWidth__y1aK5","embeddedEntry":"styles_embeddedEntry__vP68j"};